    import React from 'react'
    
    const Loader = () => {
      return (
        <div id="preloader">
            <img src="/images/loader.gif" alt="Loading......" />
        </div> 
      )
    }
    
    export default Loader
    
